module.exports = __webpack_public_path__ + "img/f.10caebd2.jpg";